import { Button, Modal } from "antd";
import React, { Component } from "react";
import "./modal-warning.scss";
export default class ModalWarning extends Component {
  render() {
    return (
      <div>
        <Modal
          title={null}
          footer={null}
          closable={false}
          centered
          visible={this.props.visible}
          width="464px"
        >
          <div className="modal-warning-custom">
            <div>
              <div className="modal-title">
                <div className="modal-title-icon">
                  <i className="fas fa-exclamation-circle" />
                </div>

                <div className="modal-title-text">{this.props.title}</div>
              </div>

              <div className="modal-footer">
                <Button
                  className="modal-button button-no"
                  onClick={this.props.onCancel}
                >
                  Không
                </Button>
                <Button
                  className="modal-button button-yes"
                  type="primary"
                  onClick={this.props.onOk}
                >
                  Có
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
